import type { FinanceQueueItem } from '@/api/generated/types.gen';

/** Counts describe the loaded page, never imply aggregation beyond the API's limit. */
export function QueueOverview({ items, total }: { items: readonly FinanceQueueItem[]; total: number }) {
  const stats = [
    { label: 'Awaiting confirmation', value: total, hint: 'All matching payments', tone: 'text-primary' },
    { label: 'Overdue', value: items.filter((item) => item.overdue).length, hint: 'On this page', tone: 'text-destructive' },
    { label: 'Due today', value: items.filter((item) => item.today && !item.overdue).length, hint: 'On this page', tone: 'text-foreground' },
    { label: 'Waiting for provider', value: items.filter((item) => item.origin === 'refund' && item.refund_status === 'open').length, hint: 'Refunds on this page', tone: 'text-foreground' },
  ];
  return (
    <dl aria-label="Payment overview" className="grid grid-cols-2 gap-3 xl:grid-cols-4">
      {stats.map(({ label, value, hint, tone }) => (
        <div key={label} className="rounded-[var(--radius-card)] border border-[var(--border-hairline)] bg-card p-4">
          <dt className="text-sm font-medium text-muted">{label}</dt>
          <dd className={`mt-2 text-3xl font-semibold tabular-nums ${value > 0 ? tone : 'text-foreground'}`}>{value}</dd>
          <dd className="mt-1 text-xs text-muted">{hint}</dd>
        </div>
      ))}
    </dl>
  );
}
